import { AppConfig } from '@/data/apps/apps';

export const memo: AppConfig = {
    title: 'memo',
    top: 200,
    left: 300,
    label: '메모',
};
